getSchedule